module.exports = __webpack_public_path__ + "img/security-1000.1e6f9d94.gif";